import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableRow, makeStyles, Button } from "@material-ui/core";
import { MdClose } from "react-icons/md";
import { BsFillXOctagonFill } from "react-icons/bs";
import { Label } from "reactstrap";
import APIutil from "api/APIutils";
import * as url from "api/url";
import { useGetLocalizationLabel } from "./useAPIMethods"; 
import { TitleHeaderLabel, EditButton, TableCellLabel, MiniStyledInput, TableCellLabelinYears, FormErrorSectionDiv, ErrorModal, HeaderTitle, FooterButtons, EditActions, SpinnerContainer } from "./styled";
import { isEmptyErrorValues } from './constants';
import Spinner from "components/common/LegacySpinner";

const EditSignCertificate = ({ getCertificateDetails, certificateDetails, data, onCancel, isCloud }) => {
  const [state, setState] = useState({
    rootCertificateSubjectName: "",
    rootCertificateValidity: null,
    hubPort: 47808,
    operationalCertificateValidity: null,
    loading: false,
  });
  const [formError, setFormError] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const useStyles = makeStyles(theme => ({
    table:{
      width: "auto",
      tableLayout: "fixed",
    },
    cell_long: {
      width: 500,
      borderBottom: "0px",
    },
    cell_medium: {
      width: 350,
      borderBottom: "0px",
    },
    cell_short: {
      width: 200,
      borderBottom: "0px",  
    },
    cell_year: {
      width: 200,
      borderBottom: "0px",
      display: "inline-block",
      marginLeft: "-200px",
    },
  }));
  const classes = useStyles();
  const { getLabel, getErrorLabel } = useGetLocalizationLabel();
  const formData = {
    "RootCertificateSubjectName": state["rootCertificateSubjectName"],
    "RootCertificateValidity": state["rootCertificateValidity"],
    "HubPort": state["hubPort"],
    "OperationalCertificateValidity": state["operationalCertificateValidity"]
  }

  useEffect(() => {
        setState(prevState => ({
          ...prevState,
          rootCertificateSubjectName: certificateDetails !== null && certificateDetails !== undefined && certificateDetails.certSubject ? certificateDetails.certSubject : "",
          rootCertificateValidity: data !== null && data !== undefined && data.rootCertValidityYear ? data.rootCertValidityYear : null,
          hubPort: data !== null && data !== undefined && data.portNumber ? data.portNumber : 47808,
          operationalCertificateValidity: data !== null && data !== undefined && data.oprCertValidityYear ? data.oprCertValidityYear : null,
        }))
  },[])

  const onChangeFields = (id,value) => {
    let updatedErrorValue = {...formError};
    if(!value.length){ //Empty Field Validation
      updatedErrorValue[id] = getErrorLabel("EntryRequired");
    }else if(id === "hubPort"){  //Port validation
      var numbers = /^[0-9]+$/;
      var range = /^(1|6[0-5][0-5][0-3][0-4]|[1-5][0-9][0-9][0-9][0-9]|[1-9][0-9]{0,3})$/
      if(value && (!value.match(numbers) || !value.match(range))){
        updatedErrorValue["hubPort"] = !value.match(numbers) ? getErrorLabel("InvalidPort") : getErrorLabel("InValidRangePort");
      }else{
        updatedErrorValue["hubPort"] = "";
      }
    }else{
      updatedErrorValue[id] = "";
    }

    setState(prevState => ({
      ...prevState,
      [id]: value,
    }))    
    setFormError(updatedErrorValue);
  }

  const blockInvalidChar = (e) =>
  ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();

  const saveCertificateDetails = async(data, callBackFunction) => {
    try{
      const response = await APIutil.postData(url.update_secure_connect_settings, data);
      if (response && response.status === 200) {
        callBackFunction && callBackFunction("success");
      } else {
        const message =
          response && response.statusText
            ? response.statusText
            : "Something went wrong. Please try refreshing the page.";
        callBackFunction && callBackFunction("error", { message });
      }
    }catch (error) {
      callBackFunction && callBackFunction("error", error);
      throw error;
    }
  }

  const handleSave = () => {
    let updatedErrorValue = {...formError};
    if(isEmptyErrorValues(updatedErrorValue)){
      setState(prevState => ({ ...prevState, loading: true }))
      saveCertificateDetails(formData,(status,error) => {
        if (status === "success") {
          setState(prevState => ({ ...prevState, loading: false }))
          onCancel();
        }else{
          setState(prevState => ({ ...prevState, loading: false }))
          console.error("Error saving data:", error);
          setShowErrorModal(true);
        }
      })
    }else{
      setFormError(updatedErrorValue)
    }
  }

  const onSaveErrorModal = () =>{
    return <>
        <HeaderTitle id="header-title">
            <div id="cancel-modal" onClick={onCancelErrorModal}><MdClose /></div>
            <label><BsFillXOctagonFill /><span>{getLabel("ImportCertificateErrorMessage") ? getLabel("ImportCertificateErrorMessage") : "Something went wrong. Please Try Again..."}</span></label>
        </HeaderTitle>
        <FooterButtons id="model-footer-section">
            <EditActions >
                <Button style={{margin : "25px 0 0 190px"}} id="cancel_button" variant="contained" onClick={onCancelErrorModal}>{getLabel("OK") ? getLabel("OK") : "OK"}</Button>
            </EditActions>
        </FooterButtons>
    </>
  }

  const onCancelErrorModal = () => {
    setShowErrorModal(!showErrorModal);
  };

  return(
    data && (data.hubMode !== "2" || !data.isHubServerEnabled)? 
      <div className="main_container">
        <div id="editCA-header-title">
          <h2 style={{ color: "black" }}>{getLabel("ManageCA") ? getLabel("ManageCA") : "Manage CA"}</h2>
        </div>
        <Table aria-label="certificate" id="manage-sign-certificate-header" className={classes.table}>
          <TableBody>
            <TableRow>
              <TableCell className={classes.cell_short}>
                <TableCellLabel>{getLabel("Port") ? getLabel("Port") : "Port"}</TableCellLabel>
              </TableCell>
              <TableCell className={classes.cell_medium}>
                <MiniStyledInput
                      id="hubPort"
                      type="number"
                      autoComplete="off"
                      value={state["hubPort"]}
                      onChange={(event) => onChangeFields("hubPort", event.target.value)}
                      error={formError["hubPort"] ? formError["hubPort"] : ""}
                      onKeyDown={blockInvalidChar}
                  />
                  {formError["hubPort"] &&
                    (
                        <FormErrorSectionDiv>
                            <p>{formError["hubPort"]}</p>
                        </FormErrorSectionDiv>
                    )
                  }
              </TableCell>
              <TableCell className={classes.cell_long}>
                  <EditButton id="save-button" primary onClick={handleSave}>
                    {getLabel("Save") ? getLabel("Save") : "Save"}
                  </EditButton>
                  <EditButton variant="contained" id="button" onClick={onCancel}>
                    {getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}
                  </EditButton>
                </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div> : 
      <div className="main_container">
        <div id="editCA-header-title">
            <h2 style={{ color: "black" }}>{getLabel("ManageCA") ? getLabel("ManageCA") : "Manage CA"}</h2>
        </div>
        <Table aria-label="certificate" id="manage-sign-certificate-header" className={classes.table}>
          <TableBody>
            <TableRow>
              <TableCell className={classes.cell_short}>
                <TitleHeaderLabel>{getLabel("CACertificate") ? getLabel("CACertificate") : "CA Certificate"}</TitleHeaderLabel>
              </TableCell>
              <TableCell className={classes.cell_medium}></TableCell>
              <TableCell className={classes.cell_long}>
                <EditButton id="save-button" primary onClick={handleSave}>
                  {getLabel("Save") ? getLabel("Save") : "Save"}
                </EditButton>
                <EditButton variant="contained" id="button" onClick={onCancel}>
                  {getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}
                </EditButton>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.cell_short}>
                <TableCellLabel>{getLabel("IssuerSubjectName") ? getLabel("IssuerSubjectName") : "Issuer Subject Name (CN)"}</TableCellLabel>
              </TableCell>
              <TableCell className={classes.cell_medium}>
                <MiniStyledInput
                      id="rootCertificateSubjectName"
                      type="text"
                      autoComplete="off"
                      value={state["rootCertificateSubjectName"]}
                      onChange={(event) => onChangeFields("rootCertificateSubjectName", event.target.value)}
                      error={formError["rootCertificateSubjectName"] ? formError["rootCertificateSubjectName"] : ""}
                  />
                  {formError["rootCertificateSubjectName"] &&
                    (
                        <FormErrorSectionDiv>
                            <p>{formError["rootCertificateSubjectName"]}</p>
                        </FormErrorSectionDiv>
                    )
                  }
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.cell_short}>
                <TableCellLabel>{getLabel("IssuerCertificateValidity") ? getLabel("IssuerCertificateValidity") : "Issuer Certificate Validity"}</TableCellLabel>
              </TableCell>
              <TableCell className={classes.cell_medium}>
                <MiniStyledInput
                      id="rootCertificateValidity"
                      type="number"
                      autoComplete="off"
                      value={state["rootCertificateValidity"]}
                      onChange={(event) => onChangeFields("rootCertificateValidity", event.target.value)}
                      error={formError["rootCertificateValidity"] ? formError["rootCertificateValidity"] : ""}
                      onKeyDown={blockInvalidChar}
                  />
                  {formError["rootCertificateValidity"] &&
                    (
                        <FormErrorSectionDiv>
                            <p>{formError["rootCertificateValidity"]}</p>
                        </FormErrorSectionDiv>
                    )
                  }
              </TableCell>
              <TableCell className={classes.cell_long}>
                <TableCellLabelinYears>Years</TableCellLabelinYears>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.cell_short}>
                <TableCellLabel>{getLabel("Port") ? getLabel("Port") : "Port"}</TableCellLabel>
              </TableCell>
              { isCloud ? 
              <TableCell className={classes.cell_medium}>
                   <Label style={{ color: "black",  fontSize: "1rem", fontFamily: "Verdana" }}>{data && data.portNumber ? data.portNumber : "47808"}</Label>
              </TableCell> :
              <TableCell className={classes.cell_medium}>
                <MiniStyledInput
                      id="hubPort"
                      type="number"
                      autoComplete="off"
                      value={state["hubPort"]}
                      onChange={(event) => onChangeFields("hubPort", event.target.value)}
                      error={formError["hubPort"] ? formError["hubPort"] : ""}
                      onKeyDown={blockInvalidChar}
                  />
                  {formError["hubPort"] &&
                    (
                        <FormErrorSectionDiv>
                            <p>{formError["hubPort"]}</p>
                        </FormErrorSectionDiv>
                    )
                  }
              </TableCell>
            }
            </TableRow>

            <TableRow>
              <TableCell className={classes.cell_short}>
                <h2 id="editCSR-header" style={{ color: "black", marginLeft: "-15px" }}>{getLabel("HeaderTitle") ? getLabel("HeaderTitle") : "Manage CSRs"}</h2>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.cell_short} style={{ padding: "4px 2px 4px 16px" }} colSpan={2}>
                <TitleHeaderLabel>{getLabel("BodyTitle") ? getLabel("BodyTitle") : "Operational Certificate Validity"}</TitleHeaderLabel>
              </TableCell>
              <TableCell className={classes.cell_medium} style={{ display: "inline-block", marginLeft: "-300px" }}>
                <MiniStyledInput
                      id="operationalCertificateValidity"
                      type="number"
                      autoComplete="off"
                      width="150px"
                      value={state["operationalCertificateValidity"]}
                      onChange={(event) => onChangeFields("operationalCertificateValidity", event.target.value)}
                      error={formError["operationalCertificateValidity"] ? formError["operationalCertificateValidity"] : ""}
                      onKeyDown={blockInvalidChar}
                  />
                  {formError["operationalCertificateValidity"] &&
                    (
                        <FormErrorSectionDiv>
                            <p>{formError["operationalCertificateValidity"]}</p>
                        </FormErrorSectionDiv>
                    )
                  }
              </TableCell>
              <TableCell className={classes.cell_year}>
                <TableCellLabelinYears>Years</TableCellLabelinYears>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={2} className={classes.cell_short}>
                <TitleHeaderLabel>{getLabel("DownloadTitle") ? getLabel("DownloadTitle") : "Upload Certificate Signing Request (CSR)"}</TitleHeaderLabel><br/>
                <label style={{ color: "black", marginLeft: "-14px", fontSize: "14px", padding: "0px" }}>{getLabel("HintText") ? getLabel("HintText") : "When a CSR is signed it becomes a Operational Certificate"}</label>
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>

        <div className="table_container" style={{ height: "auto", minHeight: "150px" }}>
          <Table id="manage-sign-certificate-csr" className="Custom_table table_border table-striped">
              <tbody className="cell_container">
                  <tr>
                      <th style={{ padding: "8px 11px", width: "23%" }} className="link_cursor">{getLabel("SubjectName") ? getLabel("SubjectName") : "Subject Name"}</th>
                      <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("Status") ? getLabel("Status") : "Status"}</th>
                      <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("ValidFrom") ? getLabel("ValidFrom") : "ValidFrom"}</th>
                      <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("ValidTo") ? getLabel("ValidTo") : "ValidTo"}</th>
                      <th style={{ padding: "8px 11px", width: "33%" }} className="link_cursor">{getLabel("Description") ? getLabel("Description") : "Description"}</th>
                      <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("Certificate") ? getLabel("Certificate") : "Certificate"}</th>
                      <th style={{ padding: "8px 11px" }} ></th>
                  </tr>
                  {getCertificateDetails()}
              </tbody>
          </Table>
        </div>

        {showErrorModal && (<ErrorModal
        isOpen={!state.isModelOpen}
        >
          {onSaveErrorModal()} 
        </ErrorModal>)
        }
        {state.loading ? 
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer> : null
        }
      </div>
  )
 }
 export default EditSignCertificate